import classNames from 'classnames';
import ArrowDropRight from 'icons/lib/arrow_drop_right.svg';
import Link from 'next/link';
import { ReactNode } from 'react';
import { CSSTransition } from 'react-transition-group';

import { useProductList } from '@/modules/product/context/productList';
import { listCategoriesBySlug } from '@/modules/product/pages/productsListPage/utils';
import { CategoryThreeItem } from '@/shared/api/endpoints/menu';
import { routes } from '@/shared/data/routes';
import { useCurrentLocale } from '@/shared/utils/client';

import styles from './CategoryThree.module.scss';

export const CategoryThree = () => {
  const locale = useCurrentLocale();
  const { categoryThree, categorySlug, productMenuOpen } = useProductList();
  const clearedSlug = categorySlug.includes('%')
    ? categorySlug.split('%')[0]
    : categorySlug;

  const renderList = (list: CategoryThreeItem[]): ReactNode => {
    return list.map((item, index) => (
      <div key={index}>
        <Link
          className={classNames(styles['categoryThree__item--link'], {
            [styles['categoryThree__item--link--active']]:
              clearedSlug === item.slug || clearedSlug === item.slug_temporary,
          })}
          href={`${routes[locale].PRODUCTS_LIST}/${item.slug_temporary ?? item.slug}`}
          key={item.slug}
        >
          {item.name}
        </Link>
      </div>
    ));
  };

  const { listCategories, parentCategory } = listCategoriesBySlug(
    clearedSlug,
    categoryThree
  );

  return (
    <nav
      className={classNames(styles.categoryThreeNav, {
        [styles.categoryThreeNavOpen]:
          productMenuOpen && listCategories.length > 0,
      })}
    >
      <CSSTransition
        in={productMenuOpen}
        unmountOnExit
        timeout={100}
        classNames={{
          enter: styles.categoryThreeNavTransitionEnter,
          enterDone: styles.categoryThreeNavTransitionEnterDone,
          exit: styles.categoryThreeNavTransitionExit,
          exitActive: styles.categoryThreeNavTransitionExitActive,
        }}
      >
        <div>
          <div className={styles.categoryThree__container}>
            {parentCategory && (
              <Link
                className={styles.categoryThree__back}
                href={`${routes[locale].PRODUCTS_LIST}/${parentCategory.slug_temporary ?? parentCategory.slug}`}
              >
                <ArrowDropRight />
                {parentCategory.name}
              </Link>
            )}
            {renderList(listCategories)}
          </div>
        </div>
      </CSSTransition>
    </nav>
  );
};
